import { EventType } from '@/constants/event'
import { MessageType } from '@/constants/message'
import { eventBus } from '@/instance'
import { EventBus } from '@/utils/eventBus'
import { connect } from 'socket.io-client'
class Kafka extends EventBus {
  connected = false
  waitingTasks: Function[]
  failedCount = 0
  ws: any
  url: string
  path: string
  retryTimes: number
  query: Object
  constructor(
    opt = {
      path: 'socket.io',
      query: {},
      retryTimes: 50,
      url: '/',
    }
  ) {
    super()
    this.url = opt.url
    this.retryTimes = opt.retryTimes
    this.query = opt.query
    this.path = opt.path
    this.ws = null
    this.waitingTasks = []
    this.init()
  }
  reconnect (err: any) {
    console.log('reconnect ', err)
    this.connected = false
    this.deinit()
    if (this.failedCount < this.retryTimes) {
      this.init()
    }
    this.failedCount++
  }
  deinit () {
    this.connected = false
    this.ws && this.ws.close()
    this.waitingTasks = []
  }
  init () {
    this.ws = connect(this.url, {
      transports: ['websocket'],
      path: this.path,
      query: this.query,
    })
    Object.values(MessageType).forEach(key => {
      this.ws.on(key, (e: string) => {
        const data = JSON.parse(e)
        this.emit(key, data)
        this.emit('kafka', { type: key, data })
      })
    })

    this.ws.on('connect', (e: any) => {
      this.connected = true
      this.waitingTasks.forEach(f => f())
      this.waitingTasks = []
    })
    this.ws.on('error', (e: any) => this.reconnect(e))
    this.ws.on('connect_error', (e: any) => this.reconnect(e))
    this.ws.on('connect_timeout', (e: any) => this.reconnect(e))
  }
  send (type: string, message: any) {
    const f = () => {
      this.ws.emit(type, message, (e: any) => console.log(e))
    }
    if (this.connected) {
      f()
    } else {
      this.waitingTasks.push(f)
    }
  }
}
export default Kafka
